import React, { useState, useRef, useEffect, useContext } from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Badge } from "@mui/material";
import HaqtGrid from "../../components/HaqtGrid/HaqtGrid";
import { useLocation } from "react-router";
import { StringComparator } from "../../utils/StringComparator ";
import { DateComparator } from "../../utils/DateComparator";
import { getAlertSummary } from "../../services/DeviceService";
import { getAlarmSummaryNew } from "../../services/DeviceService";
import HaqtDialog from "../../components/HaqtDialog/HaqtDialog";
import { getSessionStorageItem } from "../../utils/sessionStorageUtils";
import { formatUtcToLocal } from "../Alarms/AlarmsUtills";
import "./alertnotifications.scss";
import { convertToLocalDate } from "../../utils/FormatDate";
import { getCurrentDateTime } from "../../utils/CurrentDateTime";
import { ButtonCellRenderAlert } from "./Components/ButtonCellRenderAlert";
import { createWorkOrder } from "../../services/MaintenanceServices";
import { notifyError, notifySuccess } from "../../components/Toaster/Toaster";
import ConfirmDialog from "../../components/HaqtDialog/ConfirmDialog";
import { assignWorkOrderStatus } from "../../services/DeviceService";

const AlertNotifications = () => {
  const [showAlerts, setShowAlerts] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [payload, setPayload] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [alertCount, setAlertCount] = useState(0);
  const selectedSystemData = getSessionStorageItem("haqt-selected-system");
  const systemId = selectedSystemData?.system?.id;
  const location = useLocation();
  const gridApiRef = useRef();
  const statusText = {
    0: "Unresolved",
    1: "Resolved",
  };

  const severityText = {
    0: "Info",
    1: "Warning",
    2: "Critical",
  };

  const workOrderStatusText = {
    0: "Not Rasied",
    1: "Raised",
  };

  const handleShowAlerts = () => {
    // fetchAlertSummary();
    setShowAlerts(true); // Dheeraj Edit
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setShowAlerts(false);
  };

  // Dheeraj Edit - added

  const handleModalClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setShowModal(false);
  };

  const confirmationModal = (data) => {
    setShowModal((prev) => !prev);
    // setSelectedInfo(data);

    const { id, device, name, message, severity, triggeredTime } = data;
    setId(id);
    const incidentStatus = (severity) => {
      switch (severity) {
        case "Critical":
          return 1;
        case "Warning":
          return 2;
        case "Info":
          return 3;
        default:
          throw new Error("Invalid incident status");
      }
    };

    const payload = {
      workorderId: "",
      device_serial_number: device,
      work_type: "A",
      error_Code: name,
      assigned_Technician: "",
      scheduled_date: "0001-01-01 00:00:00",
      priority: incidentStatus(severity),
      issue_Description: message,
      status: "Open",
      issue_triggered_at: triggeredTime,
      technician_Comments: "",
      manager_Comments: "",
      issue_resolved_at: "",
      attachments: [],
    };

    setPayload(payload);
  };

  const createAutoIncident = async (payload) => {
    try {
      const response = await createWorkOrder(payload);
      if (response && response.data) {
        notifySuccess("Work order Added successfully");
      }
    } catch (error) {
      console.error("Error creating work order:", error);
      notifyError("Failed to Raise Work Order");
    }
  };

  const updateWorkOrderStatusAlert = async (alertId) => {
    await assignWorkOrderStatus(alertId);
  };

  const handleSuccess = async () => {
    try {
      await createAutoIncident(payload);
      await updateWorkOrderStatusAlert(id);
      setShowModal(false);
      fetchAlertSummary();
    } catch (error) {
      console.error("Error in clickHandler: ", error);
    }
  };

  //

  const fetchAlertSummary = async () => {
    try {
      const response = await getAlarmSummaryNew();
      const alerts = response.data;
      if (alerts) {
        const now = new Date();
        const last24Hours = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        const filteredAlerts = alerts.filter((alert) => {
          const triggeredTime = new Date(alert.triggeredTime);
          return triggeredTime >= last24Hours || alert.status === 0; // Assuming status 0 means Unresolved
        });
        const unresolvedUnraisedCount = alerts.filter(
          (alert) => alert.status === 0 && alert.workOrderStatus === 0,
        ).length;

        setAlertCount(unresolvedUnraisedCount);
        // setRowData(alerts);
        setRowData(filteredAlerts);
        // setShowAlerts(!showAlerts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [columnDefs] = useState([
    {
      headerName: "Device",
      field: "device",
      comparator: StringComparator,
      minWidth: 100,
    },
    {
      headerName: "Error",
      field: "name",
      comparator: StringComparator,
      minWidth: 80,
    },
    {
      headerName: "Error Description",
      field: "message",
      comparator: StringComparator,
      minWidth: 500,
    },
    {
      headerName: "Severity",
      field: "severity",
      comparator: StringComparator,
      minWidth: 100,
    },
    {
      headerName: "Triggered Time",
      field: "triggeredTime",
      comparator: DateComparator,
      minWidth: 170,
      valueFormatter: (params) => {
        return formatUtcToLocal(params.value) || "";
      },
    },
    // Dheeraj Edit - removed
    // {
    //   headerName: "Status",
    //   field: "status",
    //   minWidth: 110,
    // },
    {
      headerName: "Resolved Time",
      field: "resolvedTime",
      minWidth: 170,
      hide: true,
      comparator: DateComparator,
      valueFormatter: (params) => {
        return formatUtcToLocal(params.value) || "";
      },
    },
    // Dheeraj Edit - removed
    // {
    //   headerName: "Work Order",
    //   field: "workOrderStatus",
    //   minWidth: 130,
    // },
    {
      headerName: "Action",
      width: 75,
      cellRenderer: (data) =>
        ButtonCellRenderAlert({
          data,
          // onActionComplete: fetchAlertSummary,
          confirmationModal,
        }),
      filter: false,
      sortable: false,
      pinned: "right",
      resizable: false,
      menuTabs: [],
      lockPosition: "right",
    },
  ]);

  const formatAlertData = (alerts) => {
    return alerts.map((alertInfo) => ({
      ...alertInfo,
      severity: severityText[alertInfo.severity],
      status: statusText[alertInfo.status],
      workOrderStatus: workOrderStatusText[alertInfo.workOrderStatus],
      triggeredTime: alertInfo.triggeredTime
        ? convertToLocalDate(alertInfo.triggeredTime.replace(/\.\d+$/, ""))
        : "",
      resolvedTime: alertInfo.resolvedTime
        ? convertToLocalDate(alertInfo.resolvedTime.replace(/\.\d+$/, ""))
        : "",
    }));
  };

  useEffect(() => {
    fetchAlertSummary();
  }, []);

  return (
    <div className="alert-notification-container">
      <Badge
        badgeContent={alertCount}
        color="primary"
        sx={{
          "& .MuiBadge-badge": {
            transform: "translate(-85%, -45%)", // Adjust these values as needed
            scale: "0.8", // Makes the badge 80% of its original size
          },
        }}
      >
        <NotificationsNoneIcon
          onClick={handleShowAlerts}
          className="alert-icon"
          // Dheeraj Edit - styling
          sx={{
            cursor: "pointer",
            color: "#0A6073",
            fontSize: "24px",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              color: "#0c7389",
              transform: "translateY(-2px)",
            },
            "&:active": {
              transform: "translateY(1px)",
              color: "#084e5d",
            },
          }}
        />
      </Badge>
      <HaqtDialog
        showDialog={showAlerts}
        handleClose={handleClose}
        showContent={true}
        maxWidth="lg"
        fullWidth={true}
      >
        <HaqtGrid
          rowData={formatAlertData(rowData)}
          columnDefs={columnDefs}
          isExport={true}
          gridApiRef={gridApiRef}
          tableTitleVisible={true}
          tableTitle="Alert Summary"
          sheetName="Alert Summary"
          fileName={`Alert Summary_${getCurrentDateTime()}`}
        />
        {/* Dheeraj Edit - replaced Dialog with ConfirmDialog */}
        <ConfirmDialog
          description="Are you sure want to raise this Work Order Incident?"
          title="Creat Work Order"
          handleClose={handleModalClose}
          handleSuccess={handleSuccess}
          showDialog={showModal}
          selectedInfo={payload}
        />
      </HaqtDialog>
    </div>
  );
};
export default AlertNotifications;
